import type { ExternalWorkItem } from '../../types';

export const isExternalWorkItem = (entity: any): entity is ExternalWorkItem =>
	entity.__typename === 'ExternalWorkItem';

export const getExternalWorkItemLink = (workItem: ExternalWorkItem): string | null =>
	workItem?.url ?? null;
